var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "#76C2AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.5 3.71875C6.00313 3.71875 3.98438 5.71094 3.98438 8.18125C3.98438 12.0859 8.5 14.875 8.5 14.875C8.5 14.875 13.0156 12.1656 13.0156 8.18125C13.0156 5.71094 10.9969 3.71875 8.5 3.71875ZM8.5 10.0938C7.33125 10.0938 6.375 9.1375 6.375 7.96875C6.375 6.8 7.33125 5.84375 8.5 5.84375C9.66875 5.84375 10.625 6.8 10.625 7.96875C10.625 9.1375 9.66875 10.0938 8.5 10.0938Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.1875C6.00313 3.1875 3.98438 5.17969 3.98438 7.65C3.98438 11.5547 8.5 14.3438 8.5 14.3438C8.5 14.3438 13.0156 11.6344 13.0156 7.65C13.0156 5.17969 10.9969 3.1875 8.5 3.1875ZM8.5 9.5625C7.33125 9.5625 6.375 8.60625 6.375 7.4375C6.375 6.26875 7.33125 5.3125 8.5 5.3125C9.66875 5.3125 10.625 6.26875 10.625 7.4375C10.625 8.60625 9.66875 9.5625 8.5 9.5625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f76a79e605560933fdc5ba7f85308208.svg";
export { ForwardRef as ReactComponent };